import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { API } from "@/api";
import { Textarea } from "@/components/ui/textarea";
import { Star, Sparkles } from "lucide-react";

export default function Feedback() {
  const { token } = useParams();
  const [job, setJob] = useState(null);
  const [err, setErr] = useState("");
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    axios.get(`${API}/feedback/${token}`).then((r) => {
      setJob(r.data);
      if (r.data.rating) setDone(true);
    }).catch(() => setErr("This feedback link is invalid or expired."));
  }, [token]);

  const submit = async () => {
    try {
      await axios.post(`${API}/feedback/${token}`, { rating, comment });
      setDone(true);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-6" data-testid="feedback-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center"><Sparkles size={18} className="text-primary-foreground" /></div>
          <span className="font-heading font-bold">Cleanmates Group</span>
        </div>
        {err && <div className="text-center text-danger-foreground" data-testid="feedback-error">{err}</div>}
        {done && !err && (
          <div className="text-center" data-testid="feedback-thanks">
            <div className="text-5xl font-heading font-extrabold text-primary">Thank you!</div>
            <p className="text-muted-foreground mt-3 text-sm">Your feedback helps us keep our teams sharp.</p>
          </div>
        )}
        {job && !done && !err && (
          <div className="bg-surface border border-border rounded-2xl p-6 space-y-5">
            <div>
              <div className="text-xs uppercase tracking-widest text-muted-foreground">How was your service?</div>
              <div className="font-heading font-semibold mt-1">{job.service} · {job.company}</div>
              <div className="text-xs text-muted-foreground font-mono mt-0.5">{job.job_no}</div>
            </div>
            <div className="flex justify-center gap-2" data-testid="rating-stars">
              {[1, 2, 3, 4, 5].map((s) => (
                <button key={s} data-testid={`star-${s}`} onClick={() => setRating(s)} className="p-1 transition-transform hover:scale-110">
                  <Star size={36} className={s <= rating ? "text-warning-foreground" : "text-foreground"} fill={s <= rating ? "currentColor" : "none"} />
                </button>
              ))}
            </div>
            <Textarea data-testid="feedback-comment-input" placeholder="Anything we should know? (optional)" value={comment}
              onChange={(e) => setComment(e.target.value)} className="bg-background border-border text-foreground" />
            <button data-testid="feedback-submit-button" onClick={submit} disabled={!rating}
              className="w-full py-3.5 rounded-xl bg-primary text-primary-foreground font-bold disabled:opacity-40 transition-opacity">
              Submit Rating
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
